module.exports = "<sis-area-timeline-control [id]=\"id\"></sis-area-timeline-control>\n";